import { XStack, interaction } from '@mythical/ui'
import { ColorEnum, mapColor } from 'app/utils/mapColors'
import { Button } from 'app/components/primitive/Button'
import { IconClose } from 'app/components/primitive/Icon'
import RichText from 'app/components/primitive/RichText'
import { SmartLink } from 'app/components/primitive/SmartLink'
import { Container } from 'app/components/structure/Container'

export interface PromoBannerProps {
  backgroundColour?: ColorEnum
  foregroundColour?: ColorEnum
  ctaLabel?: string
  ctaLink?: string
  text?: any // RichText
  onClose?: () => void
}

export const PromoBanner = (props: PromoBannerProps) => {
  const { backgroundColour, foregroundColour, text, ctaLink, onClose } = props
  const bgColor = mapColor(backgroundColour)
  const fgColor = mapColor(foregroundColour || 'white')

  return (
    <Container
      position="relative"
      ai="center"
      variant="none"
      paddedX
      backgroundColor={bgColor}
      jc="center"
      w="100%"
      zIndex={0}
    >
      <SmartLink
        href={ctaLink}
        Component={XStack}
        jc="center"
        py="$2"
        mih="$3.5"
        w="100%"
        {...(ctaLink && {
          ...interaction.opacity,
          focusStyle: { outlineWidth: 0, ...interaction.opacity.focusStyle },
        })}
      >
        <XStack ai="center" jc="center" w="100%" pr="$3.5">
          <RichText
            content={text}
            fs={1}
            textProps={{
              size: '$2',
              color: fgColor,
              fow: '500',
              textAlign: 'center',
            }}
          />
        </XStack>
      </SmartLink>

      <Button
        size="$3"
        circular
        theme="transparent"
        onPress={onClose}
        position="absolute"
        right={0}
        {...interaction.opacity}
      >
        <IconClose color={fgColor} size={16} />
      </Button>
    </Container>
  )
}
